<template>
    <div class="w-100">
        <form @submit.prevent="save()">
            <div class="row">
                <div class="field col-12 col-md-4  mt-2 mt-md-0">
                    <label class="my-2">{{ t('importHistory-startDateLabel') }}</label>
                    <date-range-picker
                        ref="picker"
                        opens="center"
                        class="w-100"
                        :locale-data="pickerLocale"
                        :singleDatePicker="true"
                        :showWeekNumbers="false"
                        :showDropdowns="false"
                        :autoApply="false"
                        :ranges="{}"
                        v-model="startDate"
                    >
                    </date-range-picker>

                </div>

                <div class="field col-12 col-md-4  mt-2 mt-md-0">
                    <label class="my-2">{{ t('importHistory-endDateLabel') }}</label>
                    <date-range-picker
                        ref="picker"
                        opens="center"
                        class="w-100"
                        :locale-data="pickerLocale"
                        :singleDatePicker="true"
                        :showWeekNumbers="false"
                        :showDropdowns="false"
                        :autoApply="false"
                        :ranges="{}"
                        v-model="endDate"
                    >
                    </date-range-picker>

                </div>
                <div class="col-auto d-flex align-items-end">
                    <button class="btn btn-success mt-2 mt-md-0">{{ t('importHistory-startImportButton') }}</button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import keviApi from "../keviApi.js";

export default {
    components: {
        DateRangePicker,
    },
    data() {
        return {
            startDate: {
                startDate: new Date(2022, 0, 1),
                endDate: new Date(2022, 0, 1),
            },
            endDate: {
                startDate: new Date(),
                endDate: new Date(),
            },
        };
    },
    computed: {
        pickerLocale() {
            return {
                firstDay: 0,
                format: "dd-mm-yyyy",
                daysOfWeek: [
                    this.t("importHistory-daySun"),
                    this.t("importHistory-dayMon"),
                    this.t("importHistory-dayTue"),
                    this.t("importHistory-dayWed"),
                    this.t("importHistory-dayThu"),
                    this.t("importHistory-dayFri"),
                    this.t("importHistory-daySat"),
                ],
                monthNames: [
                    this.t("importHistory-monthJan"),
                    this.t("importHistory-monthFeb"),
                    this.t("importHistory-monthMar"),
                    this.t("importHistory-monthApr"),
                    this.t("importHistory-monthMay"),
                    this.t("importHistory-monthJun"),
                    this.t("importHistory-monthJul"),
                    this.t("importHistory-monthAug"),
                    this.t("importHistory-monthSep"),
                    this.t("importHistory-monthOct"),
                    this.t("importHistory-monthNov"),
                    this.t("importHistory-monthDec"),
                ],
                applyLabel: this.t("importHistory-applyLabel"),
                cancelLabel: this.t("importHistory-cancelLabel"),
            };
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        save() {
            const route = 'plugins/' + this.$route.params.pluginPlaceId + '/import-history/add';
            const options = keviApi.getOptions(route, "POST", {
                'date_start': this.startDate.startDate,
                'date_end': this.endDate.startDate,
            });
            this.$http(options).then((response) => {
                if (response.status === 201) {
                    this.$store.dispatch(
                    "notification/success",
                    this.t("importHistory-startSuccessNotification"),
                 );
                 this.$emit('historyCreated');
                }
            });

        },

    },

};
</script>
